
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M464 0H144a48 48 0 00-48 48v48H48a48 48 0 00-48 48v320a48 48 0 0048 48h320a48 48 0 0048-48v-48h48a48 48 0 0048-48V48a48 48 0 00-48-48zm-96 464H48V144h48v272a48 48 0 0048 48h272-48zm96-96H144V48h320v320z"}})])
          )
        }
      }
    